import statement from '@/http/requests/statement'

export default {
  fetchStatementList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      statement.list(data)
        .then(res => {     
          if (data.page > 1) {
            commit('UPDATE_STATEMENT_LIST', res.data.data)
          } else {
            commit('SET_STATEMENT_LIST', res.data.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addStatement({ commit }, data) {
    return new Promise((resolve, reject) => {
      statement
        .store(data)
        .then(response => {
          commit('ADD_STATEMENT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateStatement({ commit }, data){
    return new Promise((resolve, reject) => {
      statement
        .updateStatement(data)
        .then(response => {
          commit('UPDATE_STATEMENT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteStatement({ commit }, data) {
    return new Promise((resolve, reject) => {
      statement
        .delete(data)
        .then(response => {
          commit('DELETE_STATEMENT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
